import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { AlertTypes } from '@shared/models/alert';

@Component({
	selector: 'app-alert',
	imports: [CommonModule],
	templateUrl: './alert.component.html',
	styleUrl: './alert.component.scss',
})
export class AlertComponent {
	@Input() content: string | TemplateRef<unknown>;
	@Input() alertType: AlertTypes = AlertTypes.INFO;
	@Input() alertIcon: string = 'bi-info-circle-fill';
	@Input() dismissible: boolean = false;
	@Input() marginBottom: number = 16;

	isTemplate(value: unknown): value is TemplateRef<unknown> {
		return value instanceof TemplateRef;
	}
}
